import React, { useRef, useEffect, useState } from "react";
import LogCard from "../shared/LogCard";

interface NoteDisplayProps {
  notes: string;
  onDelete?: () => void;
  onEdit?: () => void;
}

const NoteDisplay: React.FC<NoteDisplayProps> = ({
  notes,
  onDelete,
  onEdit,
}) => {
  const textRef = useRef<HTMLDivElement>(null);
  const [isExpanded, setIsExpanded] = useState(false);
  const [shouldShowExpand, setShouldShowExpand] = useState(false);

  useEffect(() => {
    if (textRef.current) {
      const element = textRef.current;
      const isTruncated = element.scrollHeight > element.clientHeight;
      setShouldShowExpand(isTruncated);
    }
  }, [notes]);

  const handleCardClick = () => {
    setIsExpanded((prev) => !prev);
  };

  if (!notes) return null;

  return (
    <div onClick={handleCardClick} className="cursor-pointer">
      <LogCard
        className={isExpanded ? "bg-base-100" : ""}
        onDelete={onDelete}
        onEdit={onEdit}
      >
        <div
          ref={textRef}
          className={`text-sm text-base-content font-grotesk leading-relaxed whitespace-pre-wrap ${
            isExpanded ? "" : "line-clamp-4"
          }`}
        >
          {notes}
        </div>

        {shouldShowExpand && (
          <button
            type="button"
            onClick={(e) => {
              e.stopPropagation();
              setIsExpanded(!isExpanded);
            }}
            className="mt-1.5 text-xs text-primary hover:text-primary-dark transition-colors font-geist focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary rounded"
          >
            {isExpanded ? "Show less" : "Show more"}
          </button>
        )}
      </LogCard>
    </div>
  );
};

export default NoteDisplay;
